import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import { config } from "./firebase.config.js";

import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

import Sidebar from './components/Sidebar';
import MobileNav from './components/MobileNav';
import PrivateRoute from './components/PrivateRoute';

import { DataProvider } from './context/globaldata';

// Generic pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import User from './pages/User';

// Brew pages
import Brews from './pages/brews/Brews';
import Brew from './pages/brews/Brew';
import AddBrew from './pages/brews/AddBrew';

import defaultUserSettings from "./static/defaultUserSettings.json";

// Styling
import './styles/application.scss';

class App extends React.Component {

  state = {
    user: {},
    userSettings: defaultUserSettings,
    pageReady: false,
    brewAmountTotal: 0,
    brewsFilter: '',
    minifiedSidebar: false,
    userLimitReached: true
  }

  updateBrewAmount = () => {
    this.db.collection("brews").where("user", "==", this.state.user.uid).where('trashed', '==', false).get().then((snapshot) => {
      this.setState({
        ...this.state,
        brewAmountTotal: snapshot.size
      }, () => {
        this.checkUserLimitReached();
      })
    })
  }

  addNotification = (title, message, type, insert, container) => {
    this.notificationDOMRef.current.addNotification({
      title: title,
      message: message,
      type: type,
      insert: insert,
      container: container,
      dismiss: { duration: 5000 },
      dismissable: { click: true },
      slidingEnter: { duration: 300, cubicBezier: '' },
      slidingExit: { duration: 300, cubicBezier: '' }
    });
  }

  updateUserSettings = (data, type) => {

    if(data.target) {
      if(data.target.type === 'checkbox') {
        data = data.target.checked
      }
    }

    this.setState({
      userSettings: {
        ...this.state.userSettings,
        [type]: data
      }
    }, () => {
      this.userQuery.update(this.state.userSettings);
    });
  }

  checkUserLimitReached = () => {
    if(!this.state.userSettings.premium_user) {
      if(this.state.brewAmountTotal >= 50) {
        this.setState({
          userLimitReached: true
        });
      } else {
        this.setState({
          userLimitReached: false
        });
      }
    } else {
      this.setState({
        userLimitReached: false
      });
    }
  }

  // setTheme = (theme) => {
  //   document.querySelector('body').classList = (theme !== undefined ? theme.value : this.state.userSettings.theme.value);
  //   this.setState({
  //     ...this.state,
  //     pageReady: true
  //   })
  // };

  getUserSettings(uid) {
    this.userQuery = this.db.collection('users').doc(uid);
    this.currentSnapshot = this.userQuery.onSnapshot((currentSnapShot) => {
      if(currentSnapShot.exists) {
        this.setState({
          ...this.state,
          userSettings: currentSnapShot.data()
        });
        // this.setTheme();
      } else {
        // There are no user settings for this user, so we create some
        this.db.collection("users").doc(uid).set(defaultUserSettings);

        this.setState({
          ...this.state,
          userSettings: defaultUserSettings
        }, () => {
          // this.setTheme();
        });
      }
    });
  }

  setBrewsFilter = (filter) => {
    this.setState({
      brewsFilter: filter
    });
  }

  toggleSidebarSize = () => {
    this.setState({
      minifiedSidebar: !this.state.minifiedSidebar
    })
  }

  componentDidMount() {
    this.provider = new firebase.auth.GoogleAuthProvider();
    this.firebaseApp = firebase.initializeApp(config);
    this.storageBucketRef = firebase.storage().ref();
    this.db = firebase.firestore();
    this.notificationDOMRef = React.createRef();

    firebase.auth().onAuthStateChanged((user) => {

      if(user) {
        this.getUserSettings(user.uid);
        localStorage.setItem('expectSignIn', '1'); // Fixes firebase.auth not being ready after page reload

        this.setState({
          ...this.state,
          user: user,
          pageReady: true
        });

        this.updateBrewAmount();
      } else {

        if(this.currentSnapshot) {
          this.currentSnapshot();
        }

        localStorage.clear();
        this.setState({
          user: null,
          userSettings: null,
          pageReady: true
        })
      }
    });
  }

  render() {

    if(!this.state.pageReady) {
      return null
    }

    return (
      <Router>
        <DataProvider value={{
            storageBucketRef: this.storageBucketRef,
            userLimitReached: this.state.userLimitReached,
            db: this.db,
            addNotification: this.addNotification,
            updateUserSettings: this.updateUserSettings,
            currentUser: this.state.user,
            userSettings: this.state.userSettings,
            brewAmountTotal: this.state.brewAmountTotal,
            updateBrewAmount: this.updateBrewAmount,
            brewsFilter: this.state.brewsFilter,
            setBrewsFilter: this.setBrewsFilter,
            minifiedSidebar: this.state.minifiedSidebar,
            toggleSidebarSize: this.toggleSidebarSize
          }}>
          <Sidebar firebaseAuth={ this.firebaseApp.auth() } />
          <ReactNotification ref={ this.notificationDOMRef } />
          <main>
            <Switch>
              <PrivateRoute path="/" exact components={{ main: Dashboard }} />
              <PrivateRoute path="/brews/add" components={{ main: AddBrew, sidebar: Brews }} />
              <PrivateRoute path="/brews" exact components={{ main: false, sidebar: Brews, brewsFilter: this.state.brewsFilter }} />
              <PrivateRoute path="/brews/:brewId" exact components={{ main: Brew, sidebar: Brews, brewsFilter: this.state.brewsFilter }} />
              <PrivateRoute path="/user" exact components={{ main: User }} />
              <PrivateRoute path="/user/:status" exact components={{ main: User }} />
              <Route
                path="/login/"
                render={ (props) => <Login { ...props } db={ this.db } provider={ this.provider }/> }
              />
            </Switch>
          </main>
          <MobileNav firebaseAuth={ this.firebaseApp.auth() } />
        </DataProvider>
      </Router>
     )
  };
}

export default App;
